var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconKidsRoom = function SvgIconKidsRoom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;opacity:0;}.b{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1034 -721)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M232,192H192v40h40Z",
    transform: "translate(842 529)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M214.05,202.881a3,3,0,0,0-3.581,3.555,3,3,0,0,0-3.9,1.205l-4,6.928a3,3,0,0,0,1.1,4.1l8.661,5a3,3,0,0,0,4.1-1.1l4-6.928a3,3,0,0,0-.9-3.976,3,3,0,0,0,1.29-4.879,3.976,3.976,0,0,0,.186-1.247,4.207,4.207,0,0,1,.237-1.437,2.952,2.952,0,0,0-5.076-2.927,4.182,4.182,0,0,1-1.126.924A4,4,0,0,0,214.05,202.881Zm1.946.963,3,1.735v-.018a6.189,6.189,0,0,1,.355-2.119,1.389,1.389,0,0,0,.06-.838.943.943,0,0,0-1.035-.6,1.387,1.387,0,0,0-.7.471,6.177,6.177,0,0,1-1.664,1.358Zm-2.093,1.1a1,1,0,0,0-1,1.732l5.2,3a1,1,0,1,0,1-1.732Zm-4.233,3.33a1,1,0,0,0-1.366.366l-4,6.928a1,1,0,0,0,.366,1.366l8.661,5a1,1,0,0,0,1.366-.366l.5-.866h0l-1.733-1a1,1,0,0,1,1-1.732l1.732,1h0l1-1.732-1.733-1a1,1,0,1,1,1-1.732l1.732,1,.5-.866a1,1,0,0,0-.366-1.366Z",
    transform: "translate(842 529)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconKidsRoom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-kids_room.c0fc96e6.svg";
export { ForwardRef as ReactComponent };